import axios from 'axios';
import { BASE_URL } from './constants';

const axiosObj = axios.create({
    baseURL: BASE_URL
})


export default axiosObj;